import { MijnRoute } from '../../mijn-navigatie.model';

export const COLLECTION_CHANGE_PERMISSION_LIST: MijnRoute = {
    path: 'toestemmingslijst-wijzigen',
    navigationEvent: 'toIncassoChangePermissionList',
    regex: /^\/incasso\/toestemmingslijst-wijzigen$/,
    webcomponent: 'mijn-transacties-incasso-webcomponent',
    internalPath: '/toestemmingslijst-wijzigen'
};
